import React from 'react';
import { Box } from '@mui/material';
import CommonAddPolicy from '../../../PolicyView/CommonAddPolicy';

function ManagePolicy() {
  const styles = {
    parentBox: { height: '57vh' },
    height: { xl: '41vh !important', lg: '40vh !important' },
  };
  return (
    <Box>
      <CommonAddPolicy page="edit" styles={styles} />
    </Box>
  );
}

export default ManagePolicy;
